<template>
  <div>
    <div
      class="row result mt-2 mb-4"
    >
      <div class="col-12">
        <label v-if="$props.pair.event2">{{ minsToHour($props.pair.event1.start) }} - {{ minsToHour($props.pair.event2.end) }} (Przerwa:
          {{ $props.pair.movieBreak }} minut)</label>
        <label v-else>{{ minsToHour($props.pair.event1.start) }} - {{ minsToHour($props.pair.event1.end) }} </label>
        <div class="events">
	  <div>{{ $props.titles[$props.pair.event1.filmId] }} <span v-if="$props.pair.event1.attributeIds.includes('dubbed-lang-pl')">(PL)</span> <span v-if="$props.pair.event1.attributeIds.includes('recliners')">(KOMFORT)</span> ({{ minsToHour($props.pair.event1.start) }} - {{ minsToHour($props.pair.event1.end) }})</div>
          <div v-if="$props.pair.event2">
            Przerwa ({{ minsToHour($props.pair.event1.end) }} - {{ minsToHour($props.pair.event2.start) }})
          </div>
          <div v-if="$props.pair.event2">
            {{ $props.titles[$props.pair.event2.filmId] }}<span v-if="$props.pair.event2.attributeIds.includes('dubbed-lang-pl')">(PL)</span> <span v-if="$props.pair.event2.attributeIds.includes('recliners')">(KOMFORT)</span> ({{ minsToHour($props.pair.event2.start) }} - {{ minsToHour($props.pair.event2.end) }})
          </div>
        </div>
        <!--      ({{ minsToHour(pair.event1.start) }}) {{ titles[pair.event1.filmId] }} ({{ minsToHour(pair.event1.end) }})-->
        <!--      - {{ pair.movieBreak }} min. przerwy - ({{ minsToHour(pair.event2.start) }}) {{-->
        <!--        titles[pair.event2.filmId]-->
        <!--      }} ({{ minsToHour(pair.event2.end) }})-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    pair: {
      type: Object,
      default: null
    },
    titles: {
      type: Object,
      default: null
    }
  },
  data () {
    return {}
  },
  created () {
  },
  methods: {
    minsToHour: function (mins) {
      let m = mins % 60
      if (m < 10) {
        m = '0' + m
      }
      let h = (mins - (mins % 60)) / 60
      if (h < 10) {
        h = '0' + h
      }
      return h + ':' + m
    }
  }
}
</script>
